import {
    Component
} from "../../../../../sedestral/framework/interface/component/Component";
import * as s from "./alert.scss";
import {IAlert} from "./types/IAlert";

export class AlertComponent extends Component {

    public alert: IAlert;

    constructor(alert: IAlert) {
        super();
        this.alert = alert;

        //language=HTML
        this.template = `
            <div class="${s.componentAlert} ${this.alert.big ? s.big : ''} ${this.alert.blue ? s.blue : ''} ${this.alert.margin ? s.margin : ``}">
                ${this.alert.icon ? `<div class="${s.icon} ${s['icon_' + this.alert.icon]}"></div>` : ''}
                ${this.alert.iconComponent ? `<div class="${s.iconComponent}">${this.draw(this.alert.iconComponent)}</div>` : ''}
                <div class="${s.message}">
                    ${this.alert.message}
                </div>
                <div class="${s.actions}">
                    ${this.alert.buttonMessage ? `<button class="${s.button}">${this.alert.buttonMessage}</button>` : ""}
                </div>
            </div>
        `;
    }

    commit() {
        if (this.alert.buttonMessage) {
            this.el(s.button).onClick(() => this.onClickButton());
        }
    }

    onClickButton() {

    }
}